// This function is a required workaround for TypeScript to recognize that undefined/null values have been filtered (e.g. from an array)
// Taken from https://github.com/microsoft/TypeScript/issues/16069
export function hasValue<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null;
}
